module.exports = __webpack_public_path__ + "media/images/illustrations/donkey-santa-fcc499514baca4667aa89cde9862c31c.svg";